"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = exports.search = exports.unpin = exports.pin = exports.unsubscribe = exports.subscribe = exports.unreact = exports.react = exports.get = exports.remove = exports.update = exports.create = exports.fetch = exports.prefetch = void 0;
const constants_1 = require("../constants");
function prefetch({ groupId, params, }) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/prefetch`,
    };
}
exports.prefetch = prefetch;
function fetch({ groupId, params, }) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/fetch`,
    };
}
exports.fetch = fetch;
function create({ groupId, request, }) {
    return {
        data: request,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/create`,
    };
}
exports.create = create;
function update({ groupId, request, }) {
    return {
        data: request,
        method: 'PATCH',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/update`,
    };
}
exports.update = update;
function remove({ groupId, feedItemId, }) {
    return {
        method: 'DELETE',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}`,
    };
}
exports.remove = remove;
function get({ groupId, feedItemId, contentType, }) {
    const queryParams = contentType ? `?contentType=${contentType}` : '';
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}${queryParams}`,
    };
}
exports.get = get;
function react({ groupId, ...data }) {
    return {
        data,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/react`,
    };
}
exports.react = react;
function unreact({ groupId, ...data }) {
    return {
        data,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/unreact`,
    };
}
exports.unreact = unreact;
function subscribe({ groupId, feedItemId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}/subscribe`,
    };
}
exports.subscribe = subscribe;
function unsubscribe({ groupId, feedItemId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}/unsubscribe`,
    };
}
exports.unsubscribe = unsubscribe;
function pin({ groupId, feedItemId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}/pin`,
    };
}
exports.pin = pin;
function unpin({ groupId, feedItemId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}/unpin`,
    };
}
exports.unpin = unpin;
function search({ groupId, params, }) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/search`,
    };
}
exports.search = search;
function view({ groupId, feedItemId, }) {
    return {
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/feed/${feedItemId}/view`,
    };
}
exports.view = view;
//# sourceMappingURL=http.js.map